export default __webpack_public_path__ + "static/media/exit.dbc50e48.svg";